/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export const getCodeBlocks = (feature: BaseNode): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const project: ProjectConfiguration = feature.project;
    const DURATION = feature.getSettingValue('DURATION');
    const durationStr = DURATION.toString().replace('.', '_');
    const NAME = `delay_${feature.getID()}`;
    const startLinks = project.getNodeLinks(feature, 'delay_start');
    const elapsedLinks = project.getNodeLinks(feature, 'delay_elapsed');

    let iterruptCode = '';

    if (elapsedLinks.length > 0) {
        const link = elapsedLinks[0];

        iterruptCode += `
    /****${link.getSourceId()}****/`;
    }

    blocks.push({
        location: 'VARIABLE_DECLARATIONS',
        blockType: BlockType.CODE,
        template: `
struct k_timer ${NAME};`,
    });

    blocks.push({
        location: 'FUNCTION_DECLARATIONS',
        blockType: BlockType.CODE,
        template: `
extern void delay_handler_${NAME}(struct k_timer *timer_id);`,
    });

    blocks.push({
        location: 'FUNCTION_DEFINITIONS',
        blockType: BlockType.CODE,
        template: `
void delay_handler_${NAME}(struct k_timer *timer_id) {
    ${iterruptCode}
}`,
    });

    blocks.push({
        location: 'boot',
        blockType: BlockType.CODE,
        template: `
k_timer_init(&${NAME}, delay_handler_${NAME}, NULL);
`,
    });

    if (startLinks.length > 0) {
        const link = startLinks[0];
        const source: BaseNode = project.getFeature(link.getSettingValue('SOURCE_FEATURE')) as BaseNode;
        const sourceParams = source.getPort(link.getSettingValue('SOURCE_PORT'))?.params;
        const duration = project
            .parseCodeExpression(DURATION, sourceParams, TibboDataType.FLOAT);

        blocks.push({
            location: link.getSourceId(),
            blockType: BlockType.CODE,
            id: link.getID(),
            template: `k_timer_start(&${NAME}, K_MSEC(${duration} * 1000), K_NO_WAIT);`,
        });
    }

    return blocks;
};
